import { GetDateFromString } from "../../../../shared/scripts/date-functions";


export class Participant {
    SubjectId: string;

    StudyId: number;
    SiteNumber: number;
    AppendixId: number;

    Randomized: number;
    Consented: number;
    ScreenFail: number;
    RecoverCohort: number;

    SexId: number;
    RaceId: number;
    AgeId: number;
    HispanicId: number;
    NonWhiteHispanic: number;
    VitSymExInt: number;
    VitSymAutoDys: number;
    VitSymCogDys: number;

    DateRandomizedStr: string;
    DateConsentedStr: string;    

    DateRandomized: Date;
    DateConsented: Date;
    MonthRandomized: Date;
    MonthConsented: Date;
    WeekRandomized: Date;
    WeekConsented: Date;

    initialize(): void {

        if (this.DateConsentedStr != undefined) {
            this.DateConsented = GetDateFromString(this.DateConsentedStr, 'slash-month-day-year'); //to handle Safari Date parsing issue
            this.MonthConsented = new Date(this.DateConsented);
            this.MonthConsented.setDate(1);
            //console.log(this.DateConsented, this.MonthConsented);
        }
        else { this.MonthConsented = undefined; }
        
        if (this.DateRandomizedStr != undefined) {
            this.DateRandomized = GetDateFromString(this.DateRandomizedStr, 'slash-month-day-year'); //to handle Safari Date parsing issue
            this.MonthRandomized = new Date(this.DateRandomized);
            this.MonthRandomized.setDate(1);
        } 

        if (this.HispanicId == 1 || (this.RaceId != 6 && this.RaceId != 7) ) { this.NonWhiteHispanic = 1; } //hispanic or (not white and not unknown)
        else if (this.HispanicId == 0 && this.RaceId == 6) { this.NonWhiteHispanic = 0; } //not hispanic and white
        else { this.NonWhiteHispanic = 2; }
        this.WeekConsented = new Date(this.WeekConsented);
        this.WeekRandomized = new Date(this.WeekRandomized);
        //console.log(this);
    }
}

export class AggregatedParticipants {
    Count: number;
    RecoverCohort: number[];
    Race: number[];
    Hispanic: number[];
    NonWhiteHispanic: number[];
    Sex: number[];
    Age: number[];
    ClusterExInt: number[];
    ClusterAuto: number[];
    ClusterCogn: number[];
    ClusterSleep1: number;
    ClusterSleep2: number;
    ClusterAuto1: number;
    ClusterAuto2: number;
    ClusterEnergize1: number;
    ClusterEnergize2: number;

    aggregate(participants: Participant[]) {
        //console.log("Function called!")
        this.RecoverCohort = [0, 0, 0]; //0: no, 1: yes, 2: unknown
        this.Race = [0, 0, 0, 0, 0, 0, 0, 0]; //0: Multiple, 1: AIAN, 2: Asian, 3: Black, 4: MENA, 5: NHPI, 6: Whit, 7: Unknown
        this.Hispanic = [0, 0, 0]; //0: no, 1: yes, 2: unknown
        this.NonWhiteHispanic = [0, 0, 0]; //0: no, 1: yes, 2: unknown
        this.Sex = [0, 0, 0, 0, 0]; //0: female, 1: male, 2: intersex, 3: prefer not to answer, 4: unknown
        this.Age = [0, 0, 0, 0, 0]; //0: 18-30; 1: 31-50; 2: 51-70; 3: +70; 4: unknown
        this.ClusterExInt = [0, 0, 0]; //0: no, 1: yes, 2: unknown
        this.ClusterAuto = [0, 0, 0]; //0: no, 1: yes, 2: unknown
        this.ClusterCogn = [0, 0, 0]; //0: no, 1: yes, 2: unknown
        this.ClusterSleep1 = 0;
        this.ClusterSleep2 = 0;
        this.ClusterAuto1 = 0;
        this.ClusterAuto2 = 0;
        this.ClusterEnergize1 = 0;
        this.ClusterEnergize2 = 0;
        

        participants.forEach((p: Participant) => {
            this.RecoverCohort[p.RecoverCohort] += 1;
            this.Race[p.RaceId] += 1;
            this.Hispanic[p.HispanicId] += 1;
            this.NonWhiteHispanic[p.NonWhiteHispanic] += 1;
            this.Sex[p.SexId] += 1;
            this.Age[p.AgeId] += 1;
            this.ClusterExInt[p.VitSymExInt] += 1;
            this.ClusterAuto[p.VitSymAutoDys] += 1;
            this.ClusterCogn[p.VitSymCogDys] += 1;
            switch (p.AppendixId) {
                case (5): this.ClusterSleep1 += 1;
                    break
                case (6): this.ClusterSleep2 += 1;
                    break
                case (8): this.ClusterAuto1 += 1;
                    //console.log("Auto1 Incrementing");
                    break
                case (9): this.ClusterAuto2 += 1;
                    //console.log("Auto2 Incrementing");
                    break
                case (11): this.ClusterEnergize1 += 1;
                    break
                case (12): this.ClusterEnergize2 += 1;
                    break
            }
        });

        this.Count = participants.length;
    }
}